export default __webpack_public_path__ + "387e1ce849d1eb695ce69b35a04bdf94.svg";